import React from 'react';
import PropTypes from 'prop-types';
import parseTagNames from '../../functions/parseTagNames';

/**
 * タグ表示用コンポーネント
 * @component
 */
const DisplayTags = ({ tags, freeTag, noDataText }) => {
  const tagNames = parseTagNames(tags);
  const existTag = tags && tags.length > 0 && tagNames.length > 0;

  return (
    <React.Fragment key="tags-for-display">
      {existTag &&
        tagNames.map((levelTags, levelIndex) =>
          levelTags.map((tag, tagIndex) => {
            const key = `tag-${levelIndex}-${tagIndex}`;
            return (
              <React.Fragment key={key}>
                {tag}
                {tagIndex < levelTags.length - 1 ? ' > ' : ''}
                {tagIndex === levelTags.length - 1 &&
                levelIndex < tagNames.length - 1 ? (
                  <br />
                ) : (
                  ''
                )}
              </React.Fragment>
            );
          }),
        )}
      {freeTag && (
        <React.Fragment key="freeTag-for-display">
          {existTag && <br />}
          {freeTag}
        </React.Fragment>
      )}
      {!existTag && !freeTag && noDataText}
    </React.Fragment>
  );
};

DisplayTags.propTypes = {
  tags: PropTypes.oneOfType([PropTypes.array, PropTypes.oneOf([null])]),
  freeTag: PropTypes.string,
  noDataText: PropTypes.string,
};
DisplayTags.defaultProps = {
  noDataText: '',
  tags: [],
};

export default DisplayTags;
